import type { FC } from "react"

import { PaymentTermsDisplay } from "./PaymentTermsDisplay"

import type { VendorPayableFields } from "@/screens/CompanySettings/Accounting/hooks/useGetVendorPayableFields"
import { formatGlAccountOptionLabel } from "@/screens/CompanySettings/Accounting/utils/formatGlAccountOptionLabel"

interface DefaultExpenseAccountItemProps {
  defaultExpenseAccount: VendorPayableFields["defaultExpenseAccount"]
}

export const DefaultExpenseAccountItem: FC<DefaultExpenseAccountItemProps> = ({ defaultExpenseAccount }) => {
  const value = defaultExpenseAccount
    ? formatGlAccountOptionLabel(
        {
          number: defaultExpenseAccount.number,
          subNumber: defaultExpenseAccount.subNumber,
          title: defaultExpenseAccount.title,
        },
        !defaultExpenseAccount.isActive
      )
    : ""

  return <PaymentTermsDisplay name='Default Expense Account for Invoices' value={value} />
}
